/** A loaded outline may be applied only to the unchanged editing request. */
export async function applyFontChoice(options:{load:()=>Promise<void>;isCurrent:()=>boolean;apply:()=>void}):Promise<boolean>{
  await options.load();
  if(!options.isCurrent())return false;
  options.apply();return true;
}
